var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_2993)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_25_2993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8815 8.65348V14.8255H2.56752V8.65348H-0.003479L8.22452 0.425476L16.4525 8.65348H13.8815Z",
    fill: "#D3B36E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_2993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.45,
    height: 14.41,
    fill: "white",
    transform: "translate(0 0.419983)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_25_2993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.457,
    height: 14.399,
    fill: "white",
    transform: "translate(-0.003479 0.425476)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.0c8d4937e7b89d8939ee4d594842f779.svg";
export { ForwardRef as ReactComponent };